import {
  FETCH_DELIVERY_HOURS,
  FETCH_SPECIAL_EVENT_REASONS,
  HOURS_CLEAR_ALL,
  HOURS_FETCH_BASE_HOURS_OF_OPERATION,
  HOURS_FETCH_DAY_PART_HOURS,
  HOURS_FETCH_ROUTINE_HOURS,
  HOURS_SEND_HOLIDAYS_OFF,
  HOURS_SET_BASE_HOURS_OF_OPERATION,
  SET_BASE_OPERATION_HOUR_PERMISSION,
  HOURS_SET_BASE_OPERATION_HOURS_MODIFICATION,
  HOURS_SET_DAY_PART_HOURS,
  HOURS_SET_EDITED,
  HOURS_SET_OPERATION_HOUR,
  HOURS_SET_OPERATION_HOUR_WEEKDAYS,
  HOURS_SET_ROUTINE_HOURS,
  SPECIAL_EVENTS_OFF,
} from '../action-types/operation-hours-types';

const initialState: {
  entities: Array<any>;
  edited: boolean;
  entity: any;
  loading: boolean;
  loaded: boolean;
  weekDays: Array<any>;
  status: string;
  specialEventReasons: Array<any>;
  deliveryHours: any;
} = {
  entities: [],
  edited: false,
  entity: {},
  loading: false,
  loaded: false,
  weekDays: [],
  status: '',
  specialEventReasons: [],
  deliveryHours: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case HOURS_FETCH_DAY_PART_HOURS.REQUEST:
    case HOURS_FETCH_ROUTINE_HOURS.REQUEST:
    case HOURS_FETCH_BASE_HOURS_OF_OPERATION.REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        entities: [],
        entity: {},
      };
    case HOURS_FETCH_BASE_HOURS_OF_OPERATION.REJECTED:
    case HOURS_SET_BASE_HOURS_OF_OPERATION.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case HOURS_FETCH_ROUTINE_HOURS.SUCCESS:
    case HOURS_FETCH_DAY_PART_HOURS.SUCCESS:
    case HOURS_FETCH_BASE_HOURS_OF_OPERATION.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        entity: action.payload.data,
        dayOfWeek: action.payload.data.dayOfWeek,
      };
    case HOURS_SET_DAY_PART_HOURS.REQUEST:
    case HOURS_SET_ROUTINE_HOURS.REQUEST:
    case HOURS_SET_BASE_HOURS_OF_OPERATION.REQUEST:
      return {
        ...state,
        entities: [],
        loading: true,
        loaded: false,
      };
    case HOURS_SET_DAY_PART_HOURS.SUCCESS:
    case HOURS_SET_OPERATION_HOUR_WEEKDAYS:
      return {
        ...state,
        weekDays: [...action.payload.weekDays],
      };
    case HOURS_SET_BASE_OPERATION_HOURS_MODIFICATION:
      return {
        ...state,
        entity: action.payload,
        weekDays: [...action.payload.weekDays],
      };
    case HOURS_SET_ROUTINE_HOURS.SUCCESS:
    case HOURS_SET_OPERATION_HOUR:
      return {
        ...state,
        entity: {
          ...state.entity,
          [action.payload.hourName]: action.payload.hourValue,
          isPreviousDay: action.payload.isPreviousDay
            ? action.payload.isPreviousDay
            : state.entity.isPreviousDay,
        },
      };
    case HOURS_CLEAR_ALL:
      return {
        weekDays: [],
        dayOfWeek: [],
        entity: {},
      };
    case HOURS_SET_EDITED:
      return {
        ...state,
        edited: action.payload,
      };
    case HOURS_SEND_HOLIDAYS_OFF.REQUEST:
      return {
        ...state,
        status: 'Saving holidays data',
      };
    case HOURS_SEND_HOLIDAYS_OFF.SUCCESS:
      return {
        ...state,
        status: 'Saved holidays data',
      };
    case SPECIAL_EVENTS_OFF.REQUEST:
      return {
        ...state,
        status: 'Saving special event data',
      };
    case SPECIAL_EVENTS_OFF.SUCCESS:
      return {
        ...state,
        status: 'Saved special event data',
      };
    case FETCH_SPECIAL_EVENT_REASONS.REQUEST:
      return {
        ...state,
        specialEventReasons: [],
      };
    case FETCH_SPECIAL_EVENT_REASONS.SUCCESS:
      return {
        ...state,
        specialEventReasons: action.payload.data.reasons,
      };
    case FETCH_DELIVERY_HOURS.REQUEST:
      return {
        ...state,
        deliveryHours: {},
      };
    case FETCH_DELIVERY_HOURS.SUCCESS:
      return {
        ...state,
        deliveryHours: {
          ...action.payload.data,
        },
      };
    case SET_BASE_OPERATION_HOUR_PERMISSION:
      return {
        ...state,
        entity: {
          ...state.entity,
          ...action.payload,
        },
      };
    default:
      return state;
  }
}
